type CurrencyType = 'R$' | '$' | '€'

export const colorVariants = ["primary", "secondary", "success", "danger", "warning", "info", "light", 'dark']
export const colorVariants1 = ["primary", "secondary", "success", "danger", "warning", "info", 'dark']

export const currency: CurrencyType = 'R$'

export const currentYear = new Date().getFullYear()

export const credits = {
  website: 'https://wkfsolution.com.br/',
  name: 'WKF Solution',
  buyLink: '',
}

export const appName = 'SurgControl'
export const appTitle = 'Allent System'
export const appDescription: string = 'Sistema de gerenciamento de procedimentos médicos, equipamentos e agenda de profissionais'

export const basePath: string = ''
